<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{ $t("home.contract") }}</div>
    </div>
    <div class="popup_content">
      <!-- <template v-if="isSig === 1">
        <div class="tc_wrap" @click.stop @scroll="handleScroll">
            <div class="tc" ref="capture" id="originHtml" style="position: relative">
              <p style="height:20px;"></p>
              <p class="padding-tb title_h2">
                {{ $t("capture_tit") }}
              </p>
              <p class="padding-tb title_h2" style="position: relative;">
                {{ $t("capture_tit2") }} 
                <img  style="position: absolute;top:40%;transform: translateY(-50%);left:135px;" :src="resultImg" class="esign-img" ></img>
              </p>
              <p>{{ $t('capture_info') }}</p>
              <p>{{ $t('capture_info1') }}</p>
              <p>{{ $t('capture_info2',{'titleName':titleName}) }}</p>
              <p>{{ $t('capture_info3') }}</p>
              <p>
                <b>{{$t('capture_info4')}}</b> 
              </p>
              <p>{{ $t('capture_info5') }}</p>
              <p>{{ $t('capture_info6') }}</p>
              <p>{{ $t('capture_info7') }}</p>
              <p>
                <b>{{$t('capture_info8')}}</b> 
              </p>
              <p>{{ $t('capture_info9') }}</p>
              <p>{{ $t('capture_info10') }}</p>
              <p>{{ $t('capture_info11') }}</p>
              <p>{{ $t('capture_info12') }}</p>
              <p>{{ $t('capture_info13') }}</p>
              <p>{{ $t('capture_info14') }}</p>
              <p>
                <b>{{$t('capture_info15')}}</b> 
              </p>
              <p>{{ $t('capture_info16') }}</p>
              <p>{{ $t('capture_info17') }}</p>
              <p>{{ $t('capture_info18') }}</p>
              <p>
                <b>{{$t('capture_info19')}}</b> 
              </p>
              <p>{{ $t('capture_info20') }}</p>
              <p>{{ $t('capture_info21') }}</p>
              <p>
                <b>{{$t('capture_info22')}}</b> 
              </p>
              <p>{{ $t('capture_info23') }}</p>
               <p>
                <b>{{$t('capture_info24')}}</b> 
              </p>
              <p>{{ $t('capture_info25') }}</p>
              <p>{{ $t('capture_info26') }}</p>
              <p>
                <b>{{$t('capture_info27')}}</b> 
              </p>
              <p>{{ $t('capture_info28') }}</p>
              <p>{{ $t('capture_info29') }}</p>
              <p>
                <b>{{$t('capture_info30')}}</b> 
              </p>
              <p>{{ $t('capture_info31') }}</p>

              <p style="height:26px"></p>

              <p class="b">
                {{ $t('capture_info32') }}
              </p>
              <p style="height:20px"></p>
              <p class="b" style="position:relative">
                {{$t('capture_info33')}} <span style="display:inline-block;width:100px;border-bottom: 1px solid #333;padding:0 10px;position:absolute;bottom:0px;left:105px;"></span> <img  style="position: absolute;top:-30%;transform: translateY(-50%);left:115px;" :src="resultImg" class="esign-img" ></img>
              </p>
              <p class="b">
                {{ $t('capture_info34') }}<span style="border-bottom: 1px solid #333;padding:0 10px;">{{ year }}.{{ month }}.{{ day }}</span>
              </p>
              <p class="b"></p>
              <p>
                <img class="esign-img2" src="@/assets/images/seal.png" />
              </p>
              <p style="height: 105px"></p>
            </div>
          </div>
          <van-popup
            v-model:show="visible"
            class="esign-container"
            :close-on-click-overlay="false"
            get-container="#app"
          >
            <vue-esign
              class="sign-view"
              ref="esign"
              :width="800"
              :height="500"
              :isCrop="isCrop"
              :lineWidth="lineWidth"
              :lineColor="lineColor"
              bgColor.sync=""
            />
            <div class="btn-list">
              <div class="btn-left">
                <button class="warning" @click="reset">{{ $t("重置") }}</button>
                <button class="warning" @click="goback">{{ $t("返回上一步") }}</button>
              </div>
              <button class="primary" @click="save">{{ $t("confirm") }}</button>
            </div>
          </van-popup>
          <div style="height: 10px"></div>
          <div class="pop-bnt">
            <div @click="agreement" style="pointer-events: auto">
              <button
                type="primary"
                color="var(--color-main)"
                class="button"
                :class="{ 'disabled-btn': scrollDisbled }"
                :readonly="scrollDisbled"
              >
                {{ $t("同意并签名") }}
              </button>
            </div>
            <button
              type="primary"
              color="var(--color-main)"
              class="button"
              :class="{ 'disabled-btn': scrollDisbled }"
              :disabled="scrollDisbled"
              @click="argeementEsign"
            >
              {{ $t("confirm") }}
            </button>
          </div>
          <div style="height: 10px"></div>
      </template> -->
      <template v-if="isSig === 2 && sign_img != ''">
        <iframe
            :src="sign_img?sign_img:''"
            id="iframeBox"
            ref="iframeRef"
            frameborder="0"
            style="width: 100%; height: 100dvh"
        ></iframe>
      </template>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";
import vueEsign from "vue-esign";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import axios from 'axios';
import pdf from 'vue-pdf'
let dates = new Date()
export default {
  name: "activity",
  components: {
    vueEsign,
    pdf
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      data: {},
      esign: null,
      resultImg: null,
      lineWidth: 6,
      lineColor: "#000000",
      isCrop: false,
      scrollDisbled: true,
      visible: false,
      sign_img:'',
      titleName:'',
      isSig:1,
      id:'',
      year:dates.getFullYear(),
      month:dates.getMonth()+ 1,
      day:dates.getDate(),
    };
  },
  created() {
    this.$parent.footer('item',false)
    // console.log(this.$route.query,'this.$route.query')
    let params = this.$route.query
    this.id = Number(params.id)
    this.isSig = Number(params.status)
    if(this.isSig === 2) {
      Fetch("/user/getSubscriptionContracDetail",{id:this.id}).then((r) => {
          // console.log(r,'rrr')
            this.sign_img = r.data.sign_img
        });
    }
    // Fetch("/user/getSubscriptionContracDetail",{id:this.id}).then((r) => {
    //     this.sign_img = r.data
    // });
  },
  mounted() {},
  methods: {
    agreement() {
      if (this.scrollDisbled) {
        this.$toast(this.$t("ydht"));
      } else {
        this.visible = true;
      }
      // this.show=false;
      // this.checked=true;
    },
    argeementEsign() {
      if (this.resultImg) {
        this.getImg();
      } else {
        this.$toast(this.$t("请签字后再提交"));
      }
    },
    reset() {
      this.$refs.esign.reset();
      this.resultImg = null;
    },
    save() {
        this.$toast.loading({
            message: this.$t("upLoading"),
            forbidClick: true,
            duration:0
        });
        // 可选配置参数 ，在未设置format或quality属性时可在生成图片时配置 例如： {format:'image/jpeg', quality: 0.5}
        this.$refs.esign.generate({ format: "image/jpeg", quality: 0.5 });
        this.$refs.esign.generate()
            .then((res) => {
                // console.log("res ->", res);
                this.resultImg = res;
                this.visible = false;
                this.$toast.clear()
            })
            .catch((err) => {
            // 画布没有签字时会执行这里 'Not Signned'
            // this.$message.error("您还未完成签字，请签字完成后保存");
                this.$toast(this.$t("请签字后再提交"));
            });
    },
    convertBase64ToFile(urlData, filename) {
      var arr = urlData.split("base64,");
      var type = arr[0].match(/:(.*?);/)[1];
      var fileExt = type.split("/")[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename + "." + fileExt, {
        type: type,
      });
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      console.log(scrollTop, clientHeight, scrollHeight);
      if (scrollTop + clientHeight + 2 >= scrollHeight) {
        // alert('滚动到底部啦')
        this.scrollDisbled = false;
        console.log(this.scrollDisbled);
      }
    },
    goback() {
      this.$refs.esign.reset();
      this.resultImg = null;
      this.visible = false;
    },
    getImg() {
      let that = this;
      this.$toast(this.$t("loading"))
      this.$refs.capture.scrollTop = 0;
      this.$refs.capture.style.fontSize = "24px";
      if (window.top) {
        this.$refs.capture.style.width = "1220px";
        this.$refs.capture.style.paddingRight = '20px';
      }
      html2Canvas(this.$refs.capture, {
        allowTaint: true,
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        // console.log(canvas, "canvas");
        //内容的宽度
        let contentWidth = canvas.width;
        //内容高度
        let contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度,a4纸的尺寸[595.28,841.89];
        let pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        let leftHeight = contentHeight;
        //页面偏移
        let position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        //canvas转图片数据
        let pageData = canvas.toDataURL("image/jpeg", 1);
        //新建JsPDF对象
        let PDF = new JsPDF("", "pt", "a4");
        //判断是否分页

        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 10, 1, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 10, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        let blob = this.convertBase64ToFile(PDF.output("dataurlstring"), "esign.pdf");
        // PDF.save('esign.pdf')
        let fileOfBlob = new File([blob], "esign.pdf");
        let formData = new FormData(); //通过formdata上传
        // console.log("fileOfBlob ->", fileOfBlob);
        formData.append("file", fileOfBlob);
        formData.append("moduleName", "seller");
        formData.append("type", "file");
        formData.append('language', this.$i18n.locale || "en_us");
		    formData.append('token', localStorage.getItem('token'));
        this.$refs.capture.style.fontSize = "14px";
        if (window.top) {
            this.$refs.capture.style.width = "100%";
        }
        axios.post(Api.commonUrl + "/api/index/upload_sign_img", formData).then(res => {
            // this.$toast(res.data.info);
            sessionStorage.setItem('backParams', JSON.stringify({
              message: res.data.data,
              timestamp: new Date().getTime()
            }));
            this.$router.back();
            // Fetch("/index/item_apply", {
            //     sign_img: res.data.data,
            // }).then((r) => {
            //     that.sign_img = r.data.sign_img
            //     that.isSig = 2
            // });
        })
      });
    },
  },
};
</script>

<style lang="less" scoped>
.esign-container {
    width: fit-content;
    border-radius: 10px;
    position: fixed;
    left: 50%;
    transform: translate(-50%,-50%) !important;
}
.red_top_bg {
  position: fixed;
  top: 0;
  z-index: 10;
}
.basic_wrap {
  position: relative;
}
.big_tit {
  color: #000000;
}
.popup_content {
  width: 100%;
  height: fit-content;
  padding: 44px 0 0px 0px !important;
  max-width: 1250px;
  .tc_wrap {
    width: 98%;
    height: calc(100dvh - 180px);
    position: relative;
    padding: 10px 5px 10px 10px;
    margin: 0 auto;
    overflow-y: scroll;
    background: #eee;
    border-radius: 10px;
  }

  .close-btn {
    width: 24px;
    height: 24px;
    top: 10px;
    right: 10px;
  }
}
.popup_content .title_h {
  font-weight: 600;
  font-size: 21px;
  line-height:26px;
  text-align: center;
}
.popup_content .title_h2 {
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
  margin: 20px auto;
}
.popup_content p {
  color: "#333" !important;
  font-size: 15px;
  line-height: 18px;
  margin: 10px auto;
  padding-right: 10px;
  word-break: break-all;
}
.red {
  color: #ee0a24;
}
.disabled-btn {
  background: #859ac8 !important;
}
.esign-content {
  width: 100%;
}
.heights {
  height: 90%;
}
.esign-img {
  width: 80px;
  margin-left: 0px;
  margin-top: 3px;
}
.esign-img4 {
  width: 80px;
  margin-left: 30px;
}
.esign-img2 {
  width: 4.75rem;
  height: auto;
  position: absolute;
  left: 24%;
  bottom: 15px;
  z-index: 0;
}
.b {
  width: 100%;
  font-weight: bold;
  margin: 20px 0px 0px 0px;
}
.esign-img3 {
  height: 20px;
}

.b {
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    margin: 10px 0px;
  }

.pop-bnt {
  width: 100% !important;
  .button {
    background: #0e3893;
    color: #fff;
    padding: 8px 20px;
    border-radius: 6px;
    margin: 0 !important;
    margin-top: 10px !important;
    border: #333 !important;
    &:nth-child(1) {
      margin-right: 20px !important;
      margin-bottom: 10px;
    }
  }
}
.pop-bnt {
  width: 28%;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;

  .van-button {
    margin: 0 !important;

    &:nth-child(1) {
      margin-right: 20px !important;
      margin-bottom: 10px !important;
    }
  }
}
.btn-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px;
    border-top: 1px solid #eee;
    .btn-left {
      display: flex;
      justify-content: center;
    }
    button {
      width: fit-content;
      height: 40px;
      margin: 5px 10px !important;
      padding: 0px 15px;    
      color: #fff;
      border-radius: 6px;
      white-space: nowrap;
    }
    .warning {
        background: #f3253d;
    }
    .primary {
        background: #0e3893;
    }
  }

</style>
